"use client";

import Link from "next/link";

const AppLaunchPromotion = () => {
	return (
		<Link
			href="https://chat.proptechbuzz.com"
			target="_blank"
			className="flex items-center justify-center gap-2 bg-gradient-to-r from-brand-primary to-[#2bffc6] py-4 text-center text-white"
		>
			<span className="text-xs font-medium sm:text-sm">🚀 LIVE GLOBAL CHATSTREAM</span>
		</Link>
	);
};

export default AppLaunchPromotion;
